import { connect } from "react-redux";
import { useEffect } from "react";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";

import { loadConfig } from "../../../redux/configuration/actions";
import { mstrPath } from "../../../utils/mstrBase";
function Configuration(props) {
  const { children, config, loadConfig, messageBundles } = props;
  const history = useHistory();

  useEffect(() => {
    if (!config) {
      try {
        loadConfig();
      } catch (e) {
        history.push(mstrPath("error?type=LOAD_PROPS_ERROR"));
      }
    }
  }, [config, loadConfig, history, messageBundles]);

  return config && children;
}

const mapStateToProps = (state) => {
  return {
    config: state.configuration,
    messageBundles: state.configuration?.messageBundles,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadConfig: loadConfig,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Configuration);
